import { getClientExtensionProperty } from "../helpers/clientExtensionHelper";

let SiteId = window?.Liferay?.ThemeDisplay?.getSiteGroupId();

let taxonomyId = getClientExtensionProperty("taxonomyId");

let employeeRangeId = getClientExtensionProperty("employeeRangeId");

let domainName = window.location.origin;

let client_ID = getClientExtensionProperty("clientId");

let client_Secret = getClientExtensionProperty("clientSecret");

let isDevelopment = "false";



export const Constants = {
  URL: {
    base: `${domainName}/`,
    auth: "/o/oauth2/token",
    getUSerInformation:
      "/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-user-information",
    additionaldocuments: "/o/c/additionaldocuments/",
    domains: `/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-domain-and-services/${SiteId}`,
    designations: `/o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${taxonomyId}/taxonomy-categories?fields=items%2Cid%2Cname&pageSize=30&restrictFields=actions`,
    employeeRange: `/o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${employeeRangeId}/taxonomy-categories?fields=items%2Cid%2Cname&restrictFields=actions&sort=name:aesc`,

    upload: `/o/headless-delivery/v1.0/sites/${SiteId}/documents?restrictFields=actions,documentType,adaptedImages,contentUrl,keywords,numberOfComments,relatedContents,renderedContents,taxonomyCategoryBriefs,siteId,externalReferenceCode,encodingFormat,documentFolderId,description,dateModified,dateCreated,creator,customFields,sizeInBytes`,
    submitForm: "/o/pms-pre-login-custom-headless/v1.0/post-onboarding-data",
  },

  publicPath: {
    localServer: "images/",
    productionServer: "/documents/d/partner-management-system/",
  },
  client: {
    id: client_ID,
    secret: client_Secret,
  },
  isDevelopment,
};

export const RequiredDocuments = [
  {
    name: "Company profile",
    id: "companyProfile",
    mandatory: true,
    docId: "",
    url: "",
    visibleForAuditOnly: false,
  },
  {
    name: "Copy of valid trade license",
    id: "copyOfValidTradeLicense",
    mandatory: true,
    docId: "",
    url: "",
    visibleForAuditOnly: false,
  },

  // ✅ Audit Only Docs
  {
    name: "Signed audit registration form",
    id: "signedAuditRegistrationForm",
    mandatory: true,
    docId: "",
    url: "",
    visibleForAuditOnly: true,
  },
  {
    name: "Ministry of economy registration certificate",
    id: "ministryOfEconomyRegistrationCertificate",
    mandatory: true,
    docId: "",
    url: "",
    visibleForAuditOnly: true,
  },
  {
    name: "CVs/Staff profile",
    id: "cvvStaffCertificate",
    mandatory: true,
    docId: "",
    url: "",
    visibleForAuditOnly: true,
    note: 'You can upload additional Cv or staff profiles using the "Upload additional documents" button below.',
  },
  {
    name: "Vat/Tax registration certificate",
    id: "vatTaxRegistrationCertificate",
    mandatory: false,
    docId: "",
    url: "",
    visibleForAuditOnly: false,
  },
];

export const AuditServices = [{ name: "Audit Services", id: "" }];

export const RequiredDocumentsID = {
  auditID: "registrationApplicationFormForAuditFirms",
};

export const Undertakings = [
  {
    id: "undertakingOne",
    title:
      "I hereby declare that the information provided in this application form is true, accurate, and complete to the best of my knowledge and belief. I understand that any false or misleading information provided, or the omission of any relevant information, may result in the rejection of my application or other appropriate actions as deemed necessary by Dubai CommerCity.",
    checked: false,
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor, quam id luctus molestie, lectus dui ornare risus, eget venenatis felis libero sit amet eros. Praesent pretium, turpis vel vulputate consequat, nulla diam hendrerit enim, vel pretium leo nulla non mauris. Sed porta magna vel pharetra cursus. Nunc consequat non nisi fermentum tristique. Vestibulum quis tortor purus. Integer sit amet augue gravida odio vulputate ultricies sit amet non enim. Sed viverra ex ac turpis finibus scelerisque. Donec a dapibus mauris. Aenean suscipit lorem ac lobortis sollicitudin. Sed ornare molestie felis id mollis. Cras sit amet dapibus est, et convallis leo. Suspendisse tristique justo accumsan nulla maximus, id bibendum tortor ultrices. Morbi non ipsum mollis, vestibulum purus sed, laoreet turpis.

        Praesent sodales quam ante, id feugiat tellus rhoncus et. Nunc et urna nulla. In fermentum sed mi ac dapibus. Nullam ullamcorper ut velit ac maximus. Nulla facilisi. Nulla ullamcorper, erat vel facilisis sodales, ex ipsum cursus nibh, ac suscipit est dolor nec quam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sit amet lacus ultricies, vestibulum quam vel, vestibulum nunc. Aliquam molestie scelerisque nisi, id venenatis leo sagittis sit amet. Nulla hendrerit, ex sed rutrum venenatis, metus dolor dictum ipsum, et posuere quam ligula quis mauris.
        
        Aenean malesuada facilisis condimentum. Etiam feugiat massa id porttitor bibendum. Nam sed libero porta leo sagittis pulvinar a dapibus felis. Mauris dignissim, sem et lobortis aliquam, felis sapien vestibulum odio, et sollicitudin leo diam non elit. Mauris et molestie odio. Donec ut tincidunt nibh. Proin dictum placerat pellentesque. Nam sollicitudin lacus purus, et iaculis ex imperdiet euismod. Integer imperdiet, mauris ac facilisis faucibus, ipsum odio hendrerit justo, ut pulvinar eros ex id tellus. Nam commodo, metus ut varius tristique, nunc neque faucibus libero, vel ornare diam tortor a metus. Suspendisse tincidunt quis leo et pretium. Pellentesque nec interdum nulla, eleifend pretium lorem. Maecenas finibus mauris in laoreet pretium.
        
        Maecenas eget malesuada sem. In hac habitasse platea dictumst. Aliquam rhoncus dui eu consequat mollis. Aliquam imperdiet quis nisi non mattis. Cras egestas mi eu ipsum molestie facilisis. Sed volutpat viverra orci, vel aliquet ante porttitor id. Integer quis nisl ac nulla blandit malesuada. Donec eros massa, pretium at mollis eu, laoreet eget tortor.
        
        Nam dictum nibh sem, non congue augue euismod in. Aliquam sollicitudin et neque nec facilisis. Vivamus gravida aliquam nisi nec posuere. Quisque suscipit nec ligula ut luctus. Phasellus vel dolor dapibus, tristique risus ac, aliquam felis. Sed fermentum id turpis a consequat. Quisque sed cursus enim, in sollicitudin purus. In eget commodo enim. Vestibulum eleifend et nisi vitae tristique. Suspendisse ut elit vulputate, vulputate augue at, congue mauris. Vivamus molestie metus vitae ligula dictum, sit amet cursus nunc convallis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
  },
];

export const countryData = require("../jsons/country.json");

export const currencyData = require("../jsons/currency.json");
